<div class="input-group me-3 mb-3 mb-md-0">
    <input type="text" class="form-control btn-min-height" [placeholder]="placeholder" (input)="onSearchInput($event)"
           [value]="name ?? ''">
  <span class="input-group-text"><i class="bi bi-search"></i></span>
</div>
